import {
  UnifiedMonitoringMessageType,
  UnifiedMonitoringOutboundMessage,
  WebSocketClientOptions,
  WSConnection,
} from '@hakimo-ui/hakimo/types';
import {
  UnifiedMonitoringWsContext,
  useWebsocketConnect,
} from '@hakimo-ui/hakimo/util';
import { ReactNode, useMemo } from 'react';

interface Props {
  url: string;
  getAccessToken?: () => Promise<string>;
  children: ReactNode;
}

export function UnifiedMonitoringProvider(props: Props) {
  const { children, url, getAccessToken } = props;

  const websocketClientOptions: WebSocketClientOptions = useMemo(
    () => ({
      isDuplicateSessionAllowed: false,
      batchDataTypes: [
        UnifiedMonitoringMessageType.UNIFIED_ALARMS,
        UnifiedMonitoringMessageType.LLM_RECOMMENDATION,
      ],
      autoReconnect: true,
      dataTypeKey: 'event_type',
      retryConfig: {
        maxRetries: 20,
      },
    }),
    []
  );

  const { disconnect, send, subscribe, wsConnectionState } =
    useWebsocketConnect(url, getAccessToken, websocketClientOptions);

  const sendWsMessage = (message: UnifiedMonitoringOutboundMessage) => {
    const updatedMessage = {
      ...message,
      sequence_trace_id: crypto.randomUUID(),
    };
    send?.(updatedMessage);
  };

  const contextVal: WSConnection = {
    connectionState: wsConnectionState,
    subscribe,
    send: sendWsMessage,
    disconnect,
  };

  return (
    <UnifiedMonitoringWsContext.Provider value={contextVal}>
      {children}
    </UnifiedMonitoringWsContext.Provider>
  );
}
